<template>
  <loan-status-alert-container :loan="loan">
    <template #borrower>
      <p>
        {{ $t("components.loan.status.alerts.rejected.message") }}
        <icon-button
          v-if="loan.comments && loan.comments.length > 0"
          size="inline"
          variant="ghost-secondary"
          @click="$emit('jump', sections.messages)"
          >{{ $t("components.loan.status.alerts.rejected.view_messages") }}</icon-button
        >
      </p>
    </template>

    <template #owner>
      <p>
        {{ $t("components.loan.status.alerts.rejected.message") }}
        <icon-button
          v-if="loan.comments && loan.comments.length > 0"
          size="inline"
          variant="ghost-secondary"
          @click="$emit('jump', sections.messages)"
          >{{ $t("components.loan.status.alerts.rejected.view_messages") }}</icon-button
        >
      </p>
    </template>

    <template #admin>
      <p>
        {{ $t("components.loan.status.alerts.rejected.message") }}
        <icon-button
          v-if="loan.comments && loan.comments.length > 0"
          size="inline"
          variant="ghost-secondary"
          @click="$emit('jump', sections.messages)"
          >{{ $t("components.loan.status.alerts.rejected.view_messages") }}</icon-button
        >
      </p>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";
import IconButton from "@/components/shared/IconButton.vue";
import { sections } from "@/components/Loan/FullLoanSections";
export default {
  name: "LoanRejected",
  components: {
    LoanStatusAlertContainer,
    IconButton,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sections,
    };
  },
};
</script>

<style lang="scss"></style>
